export const ACTION_MAP = {
  yHBTzJCEiV50QAOhSEFWdiDY8ScBDceP: {
    actionId: "65d4765b68ff1c32032e7a20",
    action: "ViewStores",
    displayName: "View Store",
  },
  W44Ztd7G49v41GA9cwKQtZcDTzzXAI6C: {
    actionId: "65d4769968ff1c32032e7a21",
    action: "TableOrder",
    displayName: "Table Order",
  },
  NbmsyKv6NuGsSpr48ivUxgAYYYjFZFEQ: {
    actionId: "65d58c9fc6d3f57fb6306836",
    action: "ViewCharity",
    displayName: "View Charity",
  },
  "36plaECSl5fIB7bu3064OyADQywZlgKv": {
    actionId: "65d58cbdc6d3f57fb6306837",
    action: "ViewMenu",
    displayName: "View Menu",
  },
  JRbHOMcB1tsB5uaEBAiO5ZQKN2FJ9BgU: {
    actionId: "65d58ccac6d3f57fb6306838",
    action: "ViewSubMenu",
    displayName: "View SubMenu",
  },
  AGJv2hm08JqGo3flT8BBQopFgwya7DGU: {
    actionId: "6628a1627e7c7985442b9c89",
    action: "InvoiceBill",
    displayName: "Invoice Bill",
  },
  QulofPwOxZEJ9ZdYL6q7yIZdZ1YW3edd: {
    actionId: "6a1d6fd591f1e409b47280da",
    action: "NewQRCodeForSales",
    displayName: "New QRCode For Sales",
  },
  dkD94k8rzebiY3qVZdKk5oDqnGyRFP8A: {
    actionId: "6a2657750274c11bc4de75f3",
    action: "Magiclink",
    displayName: "Magic Link",
  },
};

export const STORE_URLS = {
  android: "https://play.google.com/store/apps/details?id=com.ecologital.rewardstick_consumer_app",
  ios: "https://apps.apple.com/au/app/rewardstick/id6751297042",
};

export const APP_URI_SCHEME = "rewardstick";
export const ANDROID_PACKAGE = "com.ecologital.rewardstick_consumer_app";
export const APP_OPEN_TIMEOUT_MS = 2500;
